<div [ngClass]="{ 'nordic-blue-900-text white-bg': !invertedColors, 'nordic-blue-900-bg white-text': invertedColors }">
  <div class="pr-medium center grid-max-width">
    <div>
      <h2 class="font-heading-2">{{ title }}</h2>
    </div>
    <div class="grid-col-12 no-gutters pr-clear-l ms-large-t">
      <div class="col-1-12 md-col-1-3 xl-col-1-3 ms-small-b">
        <ng-content select="[sideContent]"></ng-content>
      </div>
      <div class="col-1-12 md-col-4-12 xl-col-6-12">
        <ng-content></ng-content>
      </div>
    </div>
    <div *ngFor="let button of buttons" class="flex flex--end">
      <fcom-button
        class="ms-medium-b"
        (clickBtn)="navigateTo(button.url)"
        [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
        [theme]="invertedColors ? ButtonTheme.DARK_PRIMARY_NORDIC_BLUE : ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
        [text]="button.title"
      ></fcom-button>
    </div>
  </div>
</div>
